<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="nonzero"
      d="M16 4.192c.001-.213-.082-.417-.232-.568L12.376.232c-.151-.15-.355-.233-.568-.232-.213-.001-.417.082-.568.232L8.976 2.496.232 11.24c-.15.151-.233.355-.232.568V15.2c0 .442.358.8.8.8h3.392c.226.012.447-.072.608-.232l8.696-8.744L15.768 4.8c.073-.078.132-.167.176-.264.008-.064.008-.128 0-.192.004-.037.004-.075 0-.112l.056-.04zM3.864 14.4H1.6v-2.264l7.944-7.944 2.264 2.264L3.864 14.4zm9.072-9.072l-2.264-2.264 1.136-1.128 2.256 2.256-1.128 1.136z"
    />
  </svg>
</template>
